import dayjs from "dayjs";

export const sortStringValues = (a?: string | null, b?: string | null) =>
  (a ? a.toLowerCase() : "").localeCompare(b ? b.toLowerCase() : "", undefined, { numeric: true });

export const sortDateValues = (a?: string | null, b?: string | null): number => {
  const dateA = a ? dayjs(a).valueOf() : 0;
  const dateB = b ? dayjs(b).valueOf() : 0;
  return dateA - dateB;
};
